/* DEFAULT/INTERNAL PAYMENT */
import * as React from "react";
import {CheckoutStep} from "../../../Checkout";
import {useTranslation} from "react-i18next";
import {useCheckoutViewContext} from "../../../CheckoutContextProvider/CheckoutViewContextProvider";
import {PurchaseButtonProps} from "./PurchaseButtonProps";
import {useCustomerSelector} from "../../../../../store";

const ModuleButton: React.FC<PurchaseButtonProps> = ({paymentModule, purchaseButtonErrors}) => {
  const checkoutView = useCheckoutViewContext();
  const {customer} = useCustomerSelector();
  const {t} = useTranslation(["errorcodes", "translations"]);

  if (!paymentModule) {
    return null;
  }

  return (
    <paymentModule.PurchaseButton
      gotoHandling={() => checkoutView.gotoStep(CheckoutStep.PAYMENT)}
      label={t("checkout.purchaseNow")}
      handleError={purchaseButtonErrors}
      visitorId={customer.visitorId}
    />
  );
};

export default ModuleButton;
